import React from 'react';
import { Button, Snackbar } from '@yaradigitallabs/ahua-react';

export type NotificationType = 'success' | 'destructive';

interface NotificationProps {
  message: string | string[];
  type?: NotificationType;
  onClose: () => void;
}

export const Notification: React.FC<NotificationProps> = ({
  message,
  type = 'success',
  onClose,
}) => {
  const notificationLabel = `${type.charAt(0).toUpperCase() + type.slice(1)} Notification`;

  return (
    <Snackbar
      colorConcept={type}
      label={notificationLabel}
      open
      placement="top"
    >
      <Snackbar.Content
        colorConcept={type}
        label={notificationLabel}
        open
        placement="top"
        style={{ padding: '16px' }}
      >
        <Snackbar.Body>
          <Snackbar.Description>
            {Array.isArray(message) ? (
              <ul className="list-disc">
                Failed to create soft tag:
                {message.map(msg => (
                  <li key={msg} className="ml-4">
                    {msg}
                  </li>
                ))}
              </ul>
            ) : (
              message
            )}
          </Snackbar.Description>
        </Snackbar.Body>
        <Snackbar.Tail>
          <Snackbar.Close>
            <Button
              colorConcept="inverse"
              size="xs"
              variant="ghost"
              onClick={onClose}
            >
              Close
            </Button>
          </Snackbar.Close>
        </Snackbar.Tail>
      </Snackbar.Content>
    </Snackbar>
  );
};
